import "./policy.css";

export default function Terms() {

  return (
    <div className="policy-page">

      <div className="policy-hero">
        <h1>Terms & Conditions</h1>
        <p>Please read our store terms carefully.</p>
      </div>

      <div className="policy-container">

        <div className="policy-card">
          <h2>Age Requirement</h2>

          <p>
            Customers must be 21 years or older
            to purchase smoke shop products.
          </p>
        </div>

        <div className="policy-card">
          <h2>Product Usage</h2>

          <p>
            Products sold on Apple Smoke Shop are intended
            for legal use only. Customers are responsible
            for following local laws.
          </p>
        </div>

        <div className="policy-card">
          <h2>Pricing & Availability</h2>

          <p>
            Product prices and availability may change
            without prior notice.
          </p>
        </div>

      </div>

    </div>
  );
}